export default {
  data () {
    return {
      monthlyTableColumns: [
        {prop: 'id', label: 'ID', width: '100'},
        {prop: 'intern_user_id', label: '账号ID', minWidth: '90'},
        {prop: 'intern_realname', label: '姓名', minWidth: '90'},
        {prop: 'intern_name', label: '账号', minWidth: '90'},
        {prop: 'intern_employment_type_str', label: '人员性质', minWidth: '80'},
        {prop: 'onduty_month', label: '出勤月份', minWidth: '90'},
        {prop: 'earliest_onduty_date', label: '最早出勤日期', minWidth: '90'},
        {prop: 'latest_onduty_date', label: '最后出勤日期', minWidth: '90'},
        {prop: 'onduty_date_count', label: '月度累计出勤天数', minWidth: '130'},
        {prop: 'fill_attendance_plan_str', label: '是否设置出勤计划', minWidth: '90'},
        {prop: 'monthly_avg_score', label: '月度平均绩效', minWidth: '100'},
        {prop: 'updated_at', label: '更新时间', minWidth: '130'},
      ],
      monthlyExportHeader: [
        {key: 'id', text: 'ID'},
        {key: 'intern_user_id', text: '账号ID'},
        {key: 'intern_realname', text: '姓名'},
        {key: 'intern_name', text: '账号'},
        {key: 'intern_employment_type_str', text: '人员性质'},
        {key: 'onduty_month', text: '出勤月份'},
        {key: 'earliest_onduty_date', text: '最早出勤日期'},
        {key: 'latest_onduty_date', text: '最后出勤日期'},
        {key: 'onduty_date_count', text: '月度累计出勤天数'},
        {key: 'monthly_avg_score', text: '月度平均绩效'},
        {key: 'updated_at', text: '更新时间'},
      ],
      dailyTableColumns: [
        {prop: 'id', label: 'ID', width: '100'},
        {prop: 'intern_user_id', label: '账号ID', minWidth: '90'},
        {prop: 'intern_realname', label: '姓名', minWidth: '90'},
        {prop: 'intern_name', label: '账号', minWidth: '90'},
        {prop: 'intern_employment_type_str', label: '人员性质', minWidth: '80'},
        {prop: 'onduty_month', label: '出勤月份', minWidth: '90'},
        {prop: 'onduty_date', label: '出勤日期', minWidth: '90'},
        {prop: 'audit_times_count', label: '审单总次数', minWidth: '90'},
        {prop: 'first_audit_count', label: '初审次数', minWidth: '90'},
        {prop: 'multi_audit_count', label: '复审次数', minWidth: '90'},
        {prop: 'updated_at', label: '更新时间', minWidth: '130'},
      ],
      dailyExportHeader: [
        {key: 'id', text: 'ID'},
        {key: 'intern_user_id', text: '账号ID'},
        {key: 'intern_realname', text: '姓名'},
        {key: 'intern_name', text: '账号'},
        {key: 'intern_employment_type_str', text: '人员性质'},
        {key: 'onduty_month', text: '出勤月份'},
        {key: 'onduty_date', text: '出勤日期'},
        {key: 'audit_times_count', text: '审单总次数'},
        {key: 'first_audit_count', text: '初审次数'},
        {key: 'multi_audit_count', text: '复审次数'},
        {key: 'updated_at', text: '更新时间'},
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      employmentTypeMap: state => state.auditIntern.employmentTypeMap,
    }),
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/views/audit-intern/intern-onduty.mixins.js